export const autenticado = () => {
    if (!!localStorage.getItem("DBSERVERNAME") &&
        !!localStorage.getItem("DBUSERNAME") &&
        !!localStorage.getItem("DBUSERNAME") &&
        !!localStorage.getItem("DBPID") &&
        !!localStorage.getItem("MANDNUMBER") &&
        !!localStorage.getItem("EMPNUMBER")) {
        return true
    } else {
        return false
    }
}